import { render, staticRenderFns } from "./ProductDetail1.vue?vue&type=template&id=14daef52&scoped=true"
import script from "./ProductDetail1.vue?vue&type=script&lang=js"
export * from "./ProductDetail1.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail1.vue?vue&type=style&index=0&id=14daef52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14daef52",
  null
  
)

export default component.exports